import produce from 'immer';

import { SET_ASSIGNEE, SET_SHOW_REQUIRED_TASKS_ONLY, SET_STATUSES, TOGGLE_ASSIGNEE } from './actions';

import { statusOptions } from 'bundles/apex/filters/planner_status_filters';

const initialState = { selectedAssigneeIds: [] };
statusOptions.forEach(option => initialState[option.value] = true);

export default produce((state, action) => {
  switch (action.type) {
  case SET_SHOW_REQUIRED_TASKS_ONLY:
    state.required = action.showRequiredTasksOnly;
    break;
  case SET_STATUSES:
    action.statusNames.forEach(name => state[name] = action.value);
    break;
  case TOGGLE_ASSIGNEE:
    if (state.selectedAssigneeIds.indexOf(action.id) === -1) {
      state.selectedAssigneeIds.push(action.id);
    } else {
      state.selectedAssigneeIds = state.selectedAssigneeIds.filter(id => id !== action.id);
    }
    break;
  case SET_ASSIGNEE:
    state.selectedAssigneeId = action.id;
    break;
  }
}, initialState);
